module.exports = __webpack_public_path__ + "img/gruarancione.04df0ee2.png";